var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "320px",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lv1/Illust/allEmpty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 74,
    height: 20,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lv1/Illust/allEmpty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.455998,86.3999636 C88.3681848,108.956423 56.5079602,150.464657 70.2173275,194.4956 C83.9266948,238.526544 127.672452,263.586185 158.212034,240.152105 C188.751617,216.718026 249.273117,252.063645 262.792528,184.241287 C269.900873,148.581098 253.324476,97.64673 222.879387,80.2081594 C195.420755,64.4801938 163.610923,70.4603029 132.455998,86.3999636 Z",
    id: "Path-11",
    fill: "#E9ECEF",
    transform: "translate(165.713692, 160.057941) rotate(-206.000000) translate(-165.713692, -160.057941) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(108.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9ECEF",
    fill: "#FFFFFF",
    x: 6.5,
    y: 0.5,
    width: 89,
    height: 115,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(14.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#FFFFFF",
    stroke: "#E9ECEF",
    strokeDasharray: 2
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 3.000000)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C757D",
    x: 0,
    y: 0,
    width: 23,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 7,
    width: 68,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 11,
    width: 34,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(14.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#FFFFFF",
    stroke: "#E9ECEF",
    strokeDasharray: 2
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 3.000000)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C757D",
    x: 0,
    y: 0,
    width: 23,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 7,
    width: 68,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 11,
    width: 34,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(14.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#FFFFFF",
    stroke: "#E9ECEF",
    strokeDasharray: 2
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 3.000000)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6C757D",
    x: 0,
    y: 0,
    width: 23,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 7,
    width: 68,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 11,
    width: 34,
    height: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 0,
    y: 125,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 54,
    y: 125,
    width: 10,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 77,
    y: 125,
    width: 28,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5ADB5",
    x: 68,
    y: 125,
    width: 5,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,172 C80,176.334914 83.4478378,179.864543 87.7508207,179.996193 L88,180 C83.6650857,180 80.1354571,183.447838 80.0038068,187.750821 L80,188 C80,183.581722 76.418278,180 72,180 C76.418278,180 80,176.418278 80,172 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,135 C223,139.334914 226.447838,142.864543 230.750821,142.996193 L231,143 C226.665086,143 223.135457,146.447838 223.003807,150.750821 L223,151 C223,146.581722 219.418278,143 215,143 C219.418278,143 223,139.418278 223,135 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,81 C159,84.7854517 162.004783,87.8690987 165.75935,87.995941 L166,88 C162.214548,88 159.130901,91.0047834 159.004059,94.7593502 L159,95 C159,91.1340068 155.865993,88 152,88 C155.865993,88 159,84.8659932 159,81 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,219 C106,222.785452 109.004783,225.869099 112.75935,225.995941 L113,226 C109.214548,226 106.130901,229.004783 106.004059,232.75935 L106,233 C106,229.134007 102.865993,226 99,226 C102.865993,226 106,222.865993 106,219 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,122 C85,124.688755 87.1223067,126.881818 89.7831104,126.99538 L90,127 C87.3112453,127 85.1181819,129.122307 85.0046195,131.78311 L85,132 C85,129.238576 82.7614237,127 80,127 C82.7614237,127 85,124.761424 85,122 Z",
    id: "Combined-Shape",
    fill: "#A0A0A0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,195 C231,197.688755 233.122307,199.881818 235.78311,199.99538 L236,200 C233.311245,200 231.118182,202.122307 231.00462,204.78311 L231,205 C231,202.238576 228.761424,200 226,200 C228.761424,200 231,197.761424 231,195 Z",
    id: "Combined-Shape",
    fill: "#A0A0A0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,95 C226,97.6887547 228.122307,99.8818181 230.78311,99.9953805 L231,100 C228.311245,100 226.118182,102.122307 226.00462,104.78311 L226,105 C226,102.238576 223.761424,100 221,100 C223.761424,100 226,97.7614237 226,95 Z",
    id: "Combined-Shape",
    fill: "#A0A0A0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,71 C95,73.6887547 97.1223067,75.8818181 99.7831104,75.9953805 L100,76 C97.3112453,76 95.1181819,78.1223067 95.0046195,80.7831104 L95,81 C95,78.2385763 92.7614237,76 90,76 C92.7614237,76 95,73.7614237 95,71 Z",
    id: "Combined-Shape",
    fill: "#A0A0A0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(143.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#E9ECEF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    cx: 29.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,4 C15.5,4.33333333 17.6666667,4.33333333 20,4",
    id: "Path-13",
    stroke: "#251F20",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(16.750000, 4.125000) rotate(-5.000000) translate(-16.750000, -4.125000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152,184.983333 C153.555556,185.427778 154.888889,185.316667 156,184.65",
    id: "Path-14",
    stroke: "#251F20",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(154.000000, 184.950000) rotate(4.000000) translate(-154.000000, -184.950000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,184.983333 C164.555556,185.427778 165.888889,185.316667 167,184.65",
    id: "Path-14",
    stroke: "#251F20",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllEmpty);
export default __webpack_public_path__ + "static/media/allEmpty.77e522ddeef901a704b3d86d316e68b9.svg";
export { ForwardRef as ReactComponent };